import axios from "../api";

export async function triggerReport(eventId, reportName) {
  const { data } = await axios.post(`/events/${eventId}/reporting/${reportName}`);
  return data;
}
